export default "__VITE_ASSET__Bvr8yIAX__"